<template>
  <div :class="`main-${device}`" @mouseenter="on_top_enter" @mouseleave="on_top_leave">
    <swiper :options="swiper ? swiperOption : {}" ref="mySwiper" v-if="swiperSlides.length > 0">
      <swiper-slide v-for="(item, index) in swiperSlides" :key="index">
        <div class="swipeBox" :class="item.url ? 'pointer' : ''">
          <div class="bg" v-if="device == 'mobile'"></div>
          <img :src="item.cover" />
        </div>
        <slot name="bannerinfo" :info="item.game_info"></slot>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination" v-if="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev" v-if="button"></div>
      <div class="swiper-button-next" slot="button-next" v-if="button"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  //swiperSlides表示传进来的轮播数组;button表示是否显示左右滑动;pagination表示是否显示指示点;swiper表示是否轮播
  props: ["swiperSlides", "button", "pagination", "swiper"],
  data() {
    return {
      //配置轮播相关参数
      swiperOption: {
        //指示点显示
        pagination: {
          el: ".swiper-pagination",
          clickable: true // 允许点击小圆点跳转
        },
        lazy: true,
        //自动轮播
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          stopOnLastSlide: false
        },
        loop: true,
        notNextTick: true,
        //左右按钮切换显示
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observer: true,
        observeParents: true
      }
    };
  },
  methods: {
    // 悬浮进入停住
    on_top_enter() {
      if (this.mySwiper.autoplay && this.device == "pc") {
        this.mySwiper.autoplay.stop();
      }
    },
    // 悬浮离开重新启动
    on_top_leave() {
      if (this.mySwiper.autoplay && this.device == "pc") {
        this.mySwiper.autoplay.start();
      }
    },
    // 跳转商城注册页
    jump(url, type) {
      if (type == 2) {
        window.open(url, "_blank");
      } else if (type == 1) {
        this.$router.push(url);
      }
    }
  },
  watch: {
    'swiperSlides': function (newvalue, oldvalue) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.mySwiper.slideTo(1);
          let sideheight = $(".swiper-container").height();
          if (sideheight > 0) {
            $(".swiper-slide").css(
              "height",
              sideheight + "px"
            );
          }
        }, 1000);
      });
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     // this.mySwiper.slideTo(1);
    //     $(".swiper-slide").css(
    //       "height",
    //       $(".swiper-container").height() + "px"
    //     );
    //   }, 1000);
    // });
  },
  computed: {
    mySwiper() {
      if (this.$refs.mySwiper) {
        // mySwiper 是要绑定到标签中的ref属性
        return this.$refs.mySwiper.swiper;
      }
    }
  }
};
</script>

<style lang="less" scoped="scoped">
// pc样式
.main-pc {

  /deep/ .swiper-container-horizontal>.swiper-pagination-bullets,
  /deep/ .swiper-pagination-custom,
  /deep/ .swiper-pagination-fraction {
    bottom: 2.1rem;
    text-align: right;
    width: 1200px;
    right: 0;
    left: 0;
    margin: 0 auto;
    padding-right: 95px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    background: #ffffff;
    opacity: 1;
    border: 3px solid#fff;
  }

  /deep/.swiper-pagination-bullet-active {
    background: #00b7ff;
  }

  /deep/.swiper-slide {
    height: 100%;
  }

  .swipeBox {
    // height: calc(100vh - 100px);
    background: #282c35;
    overflow: hidden;
    display: flex;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .pointer {
    cursor: pointer;
  }
}

// mobile样式
.main-mobile {

  /* 轮播图样式调整 */
  /deep/ .swiper-container-horizontal>.swiper-pagination-bullets,
  /deep/ .swiper-pagination-custom,
  /deep/ .swiper-pagination-fraction {
    bottom: 0.3333rem;
  }

  /deep/ .swiper-slide img {
    width: 100%;
  }

  /deep/ .swiper-pagination-bullet {
    width: 0.2267rem;
    height: 0.2267rem;
    border-radius: 50%;
    background: #ffffff;
    opacity: 1;
    border: 0.04rem solid#fff;
  }

  /deep/ .swiper-pagination-bullet-active {
    background: #00b7ff;
  }

  .swipeBox {
    background: #001e2d;
    height: 100%;

    /deep/.swiper-slide {
      height: 100%;
    }

    .bg {
      width: 10rem;
      height: 10rem;
      position: absolute;
      left: 0;
      bottom: 0;
      background: linear-gradient(rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.6) 100%);
    }

    img {
      width: 10rem;
      display: block;
      // padding-bottom: 3rem;
      height: 10rem;
      object-fit: cover;
      background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.6));
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    top: 50%;
    width: 0.2666rem;
    height: 0.5866rem;
    margin-top: -0.2933rem;
    z-index: 10;
    cursor: pointer;
    background-size: 0.36rem 0.5866rem;
    display: none;
  }

  .swiper-pagination-bullet {
    width: 0.1333rem !important;
    height: 0.1333rem !important;
  }

  /deep/ .swiper-pagination-bullet-active {
    background: #009ee3 !important;
  }
}</style>




// WEBPACK FOOTER //
// src/components/swiper.vue